import React, { useEffect, useState } from "react";
import * as Tooltip from "@radix-ui/react-tooltip";
import { HiMinus, HiOutlinePlus } from "react-icons/hi";
import { getAuth } from "firebase/auth";
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../scripts/firebase";
import { BiLoaderAlt } from "react-icons/bi";
import { FiCheck } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import Image from "next/image";
import { useRouter } from "next/router";

function ModalPhone({
  selectedPlan,
  listerData,
  setOpen,
  fireConfetti,
  verifyTrans,
}) {
  const [mobileNumber, setMobileNumber] = useState("");
  const [tooltip1, setTooltip1] = useState(false);
  const [months, setMonths] = useState(1);
  const [price, setPrice] = useState(selectedPlan === "PREMIUM" ? 9500 : 21500);
  const regex = new RegExp(/^\d+$/);
  const [pushingStk, setPushingStk] = useState(false);
  const [walletDeduction, setWalletDeduction] = useState(false);
  const auth = getAuth();
  const user = auth.currentUser;
  const [mpesaID, setMpesaID] = useState(null);
  const [transactionData, setTransactionData] = useState(null);
  const [tooltip2, setTooltip2] = useState(false);
  const router = useRouter();

  const [gettingLink, setGettingLink] = useState(false);

  useEffect(() => {
    let unsub;
    if (mpesaID) {
      unsub = onSnapshot(
        doc(db, "Listers", user.uid, "MpesaTransactions", mpesaID),
        (doc) => {
          // console.log("Current data: ", doc.data());
          const data = doc.data();
          const transactionID = doc.id;
          setTransactionData(
            Object.assign(
              {
                transactionID,
              },
              data
            )
          );
        }
      );
    }
    return () => {
      if (mpesaID) {
        unsub();
      }
    };
  }, [mpesaID]);

  const url = process.env.NEXT_PUBLIC_VERCEL_URL
    ? process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? "https://" + "ula.africa"
      : "https://" + process.env.NEXT_PUBLIC_VERCEL_URL
    : "http://localhost:3000";

  const getLink = async (id, listerData) => {
    //try {
    const res = await fetch(`/api/ps-link`, {
      method: "POST",
      body: JSON.stringify({
        selectedPlan,
        months: 2,
        user,
        id,
        listerName: listerData.listerInfo.listerName,
        phone: "0706402684",
        currentUrl: url + "/lister/dashboard",
      }),
    }).then(async (res) => {
      let r = await res.json();
      return r;
    });
    //console.log(res)
    if (res.message.success) {
      console.log(res.message.response.data);
      document.location.href = res.message.response.data.authorization_url;
      setGettingLink(false);
      return res;
    } else {
      setGettingLink(false);
      console.log(res.message.response);
      throw new Error(res.message.response);
    }

    // } catch (error) {
    //   console.log(error);
    // }
  };

  function payWithPaystack(id, listerData, topup, walletDeduct, total) {
    const handler = PaystackPop.setup({
      key: process.env.NEXT_PUBLIC_PS_PUBLIC_KEY,
      email: user.email,
      amount:
        listerData?.wallet.amount > 0 && topup === false
          ? total * 100
          : price * 100 * months, // the amount value is multiplied by 100 to convert to the lowest currency unit
      currency: "KES",
      // plan: "PLN_xtvrywdphci9xme",
      metadata: {
        lister_id: user.id,
        months: months ?? null,
        plan: selectedPlan ?? null,
        topup: topup,
        walletDeduct: walletDeduct,
        split: listerData?.wallet.amount > 0 && topup === false ? true : false,
        custom_fields: [
          {
            display_name: "Plan",
            variable_name: selectedPlan ?? null,
            value: selectedPlan ?? null,
          },
          {
            display_name: "Months",
            variable_name: months ?? 0,
            value: months ?? 0,
          },
          {
            display_name: "User",
            variable_name: "User",
            value: listerData.listerInfo.listerName,
          },
        ],
      },
      ref: id,
      callback: function (response) {
        const reference = response.reference;
        const txRef = response.trxref;
        // document.location.href = url+"/lister/dashboard"+response.redirecturl;
        verifyTrans(txRef, reference, user, listerData).then((res) => {
          // console.log(res)

          if (res.message.success) {
            if (!res.message.response.saved) {
              if (res.message.response.reason === "Webhook Saved") {
                fireConfetti();
                // router.replace("/lister/dashboard/properties", undefined, {
                //   shallow: false,
                // });
                return;
              }
              // router.replace("/lister/dashboard/properties", undefined, {
              //   shallow: false,
              // });
            } else if (res.message.response.saved) {
              fireConfetti();
              // router.replace("/lister/dashboard/properties", undefined, {
              //   shallow: false,
              // });
            }
          } else {
            // router.replace("/lister/dashboard/properties", undefined, { shallow: false });
          }
        });
      },
      onClose: function () {
        // alert('Transaction was not completed, window closed.');
      },
    });
    setOpen(false);
    handler.openIframe();
  }

  let remainingFunds;
  let subtotal;
  let total;
  let walletDeduct;

  function renewSubscription(walletFunds, subscriptionPrice) {
    remainingFunds = walletFunds - subscriptionPrice;
    subtotal = subscriptionPrice;
    if (remainingFunds >= 0) {
      total = 0;
      walletDeduct = subscriptionPrice;
      // console.log(
      //   "Subscription renewed using wallet funds. Remaining funds: " +
      //     remainingFunds
      // );
    } else {
      total = Math.abs(remainingFunds);
      walletDeduct = walletFunds;
      // console.log(
      //   "Subscription renewed using wallet funds and card. Wallet funds used: " +
      //     walletFunds +
      //     ". Card charged: " +
      //     Math.abs(remainingFunds)
      // );
    }
    // console.log("Subtotal: " + subtotal);
    // console.log("Wallet deduction: " + walletDeduct);
    // console.log("Total: " + total);
  }

  let walletFunds = listerData?.wallet.amount;
  //1000;
  let subscriptionPrice = price * months;
  // 9500;

  renewSubscription(walletFunds, subscriptionPrice);

  // console.log("Subtotal after renewing subscription: " + subtotal);
  // console.log("Total after renewing subscription: " + total);
  // console.log("Wallet deduction after renewing subscription: " + walletDeduct);

  return (
    <div className=" flex h-full flex-col space-x-0  space-y-10 px-10 lg:flex-row lg:space-x-12 lg:space-y-0">
      {!mpesaID && pushingStk === false ? (
        <div className=" flex w-full flex-col items-start space-y-5 lg:w-1/2">
          <div className=" flex flex-col space-y-2">
            <div className=" flex flex-col space-y-1">
              <span className=" select-none text-lg font-medium ">
                <span className="  font-semibold capitalize">
                  {selectedPlan.toLowerCase()}
                </span>
              </span>
              <span className="  select-none">
                Kshs {Intl.NumberFormat().format(price)} / month
              </span>
            </div>
            <div className="flex flex-row items-center space-x-4">
              <div className="flex flex-row items-center space-x-2">
                <div
                  onClick={() => {
                    if (months > 1) {
                      setMonths(months - 1);
                    }
                  }}
                  className={
                    " cursor-pointer rounded bg-blue-100 p-2" +
                    (months === 1 ? " bg-blue-50" : "")
                  }
                >
                  <HiMinus
                    className={
                      " " + (months === 1 ? " text-gray-700" : " text-gray-900")
                    }
                  />
                </div>
                <span className=" select-none p-2">{months}</span>
                <div
                  onClick={() => {
                    if (months < 12) {
                      setMonths(months + 1);
                    }
                  }}
                  className=" cursor-pointer rounded bg-blue-100 p-2"
                >
                  <HiOutlinePlus />
                </div>
              </div>

              <span className=" select-none text-gray-700">
                month{months > 1 ? "s" : ""}
              </span>
            </div>
          </div>
          <div className=" flex flex-col space-y-0">
            <div className="flex select-none flex-col space-y-1">
              <span className=" mb-2 text-gray-700">
                Everything in{" "}
                <Tooltip.Provider delayDuration={500}>
                  <Tooltip.Root
                    open={tooltip2}
                    onOpenChange={(op) => {
                      if (!op) {
                        setTooltip2(false);
                      }
                    }}
                  >
                    <Tooltip.Trigger
                      onClick={() => {
                        setTooltip2(!tooltip2);
                      }}
                    >
                      <span className=" cursor-pointer font-semibold hover:underline hover:decoration-dotted">
                        Flex
                      </span>
                    </Tooltip.Trigger>
                    <Tooltip.Portal>
                      <Tooltip.Content className=" z-20 w-56 rounded-md border  border-gray-800 bg-gray-800 px-4  py-3 leading-4">
                        <ul className="  text-sm text-gray-100">
                          <li>10 Active properties</li>
                          <li>Property Analytics and Insights</li>
                          <li>One to one messages</li>
                        </ul>
                        <Tooltip.Arrow className="  fill-gray-800" />
                      </Tooltip.Content>
                    </Tooltip.Portal>
                  </Tooltip.Root>
                </Tooltip.Provider>
                , plus
              </span>
              <div className="flex flex-row items-center space-x-3">
                <div className=" flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
                  <FiCheck className="text-ula-secondary h-4 w-4 flex-shrink-0" />
                </div>
                <div className=" flex flex-row items-center space-x-2">
                  <span className="text-gray-800">
                    Up to{" "}
                    <span className=" font-semibold">
                      {selectedPlan === "PREMIUM" ? "50" : "100"}
                    </span>{" "}
                    Active properties
                  </span>
                </div>
              </div>
              <div className="flex flex-row items-center space-x-3 ">
                <div className=" flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
                  <FiCheck className="text-ula-secondary h-4 w-4 flex-shrink-0" />
                </div>

                <span className="text-gray-800">
                  {" "}
                  {selectedPlan === "PREMIUM" ? "5" : "Unlimited"} team members
                </span>
              </div>
              <div className="flex flex-row items-center space-x-3">
                <div className=" flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
                  <FiCheck className="text-ula-secondary h-4 w-4 flex-shrink-0" />
                </div>
                <span className="text-gray-800">Dedicated support</span>
              </div>
            </div>

            <form
              id="mobile"
              onSubmit={async (e) => {
                e.preventDefault();
                // setPushingStk(true);
                setGettingLink(true);
                const docRef = await addDoc(collection(db, "Transactions"), {
                  selectedPlan,
                  transactionInitiatedTime: serverTimestamp(),
                  transactionCompleted: false,
                  receiptSent: false,
                  listerID: user.uid,
                  isWalletTopup: false,
                });
                // await getLink(docRef.id, listerData)
                payWithPaystack(
                  docRef.id,
                  listerData,
                  false,
                  walletDeduct,
                  total
                );
              }}
              className=" flex flex-col space-y-0"
            >
              {/* <span className=" select-none text-gray-700">
              Please enter your Mobile Number to begin payment
            </span>

            <fieldset className=" flex flex-col space-y-1">
              <input
                onChange={(e) => {
                  if (!mobileNumber || mobileNumber.length <= 10) {
                    setMobileNumber(e.target.value);
                  }
                }}
                maxLength="10"
                type="tel"
                placeholder="07XXXXXXXX"
                className=" rounded-md focus:border-ula-primary bg-gray-100 px-4 py-3 mr-16 border border-gray-400"
                required
                name="mobile"
              ></input>
            </fieldset> */}
            </form>
          </div>

          {listerData?.wallet?.amount >= subtotal ? (
            <div className=" w-full">
              <div className=" flex w-full flex-col space-y-2  pr-3 pt-2  ">
                <button
                  onClick={async () => {
                    setWalletDeduction(true);
                    // do a firestore transaction
                    const res = await fetch(`/api/wallet-upgrade`, {
                      method: "POST",
                      body: JSON.stringify({
                        price: total,
                        walletAmount: listerData?.wallet?.amount,
                        months,
                        listerID: user?.uid,
                        selectedPlan,
                        currentPlan: listerData?.currentPlan,
                        selectedPlanAmount: price,
                        upgradeToHigher:
                          listerData?.currentPlan?.plan != "FREE" &&
                          selectedPlan != listerData?.currentPlan?.plan,
                      }),
                    }).then(async (res) => {
                      let r = await res.json();
                      return r;
                    });
                    // console.log(res);
                    if (res?.success) {
                      // console.log(res.message);
                      setOpen(false);
                      setWalletDeduction(false);
                      fireConfetti();
                      return res;
                    } else {
                      // console.log(res);
                      setOpen(false);
                      setWalletDeduction(false);
                      // throw new Error(res);
                    }
                  }}
                  type={walletDeduction ? "button" : "submit"}
                  className=" w-full select-none rounded-md bg-ula-primary py-3 font-semibold text-blue-50"
                >
                  {" "}
                  {walletDeduction ? "Processing..." : "Upgrade"}
                </button>
              </div>
            </div>
          ) : (
            <div className="flex w-full flex-col">
              <div className=" flex w-full flex-col space-y-2 pr-3 pt-2  ">
                <button
                  form="mobile"
                  type={pushingStk || gettingLink ? "button" : "submit"}
                  className=" w-full select-none rounded-md bg-ula-primary py-3 font-semibold text-blue-50"
                >
                  {" "}
                  {pushingStk || gettingLink ? "Processing..." : "Upgrade"}
                </button>
              </div>
              <div className=" relative h-10 w-full select-none">
                <Image
                  className="  h-full object-contain "
                  src="/image/SBP-Badge-White.png"
                  layout="fill"
                  alt=""
                />
              </div>
            </div>
          )}
          {/* 
          <div className=" pt-2 w-full flex items-center bg-red-300">
            {mobileNumber &&
              mobileNumber.length === 10 &&
              regex.test(mobileNumber) ? (
              <button
                type={pushingStk || gettingLink ? "button" : "submit"}
                form="mobile"
                className=" bg-ula-primary w-full  text-white font-medium py-3 rounded-md"
              >
                {pushingStk || gettingLink ? "Processing..." : "Upgrade"}
              </button>
            ) : (
              <Tooltip.Provider delayDuration={500}>
                <Tooltip.Root
                  open={tooltip1}
                  onOpenChange={(op) => {
                    if (!op) {
                      setTooltip1(false);
                    }
                  }}
                >
                  <Tooltip.Trigger
                    onClick={() => {
                      setTooltip1(!tooltip1);
                    }}
                  >
                    <button
                      type="submit"
                      form="mobile"
                      className=" bg-blue-500  px-16 w-full text-white font-medium py-3 rounded-md"
                    >
                      Upgrade
                    </button>
                  </Tooltip.Trigger>
                  <Tooltip.Portal>
                    <Tooltip.Content
                      side="bottom"
                      className=" py-3 px-4 z-20 w-64  leading-4 bg-red-200 border  border-red-200 rounded-md"
                    >
                      <span className=" text-red-700 text-sm">
                        Mobile Number provided is incorrect
                      </span>
                      <Tooltip.Arrow className="  fill-red-200" />
                    </Tooltip.Content>
                  </Tooltip.Portal>
                </Tooltip.Root>
              </Tooltip.Provider>
            )}
          </div> */}
        </div>
      ) : null}

      {pushingStk || mpesaID || transactionData ? (
        <div className=" flex w-full flex-col items-start space-y-6 lg:w-1/2 lg:pt-10">
          {pushingStk && mpesaID ? (
            <div className="  flex flex-row items-center space-x-3 text-gray-800">
              <div className=" rounded-full bg-green-100  p-1">
                <FiCheck className="h-4 w-4 text-green-600" />
              </div>
              <span className=" text-gray-900">Pushed STK</span>
            </div>
          ) : (
            <div className="  flex flex-row items-center space-x-3 text-gray-800">
              <BiLoaderAlt className=" invisible h-5 w-5 animate-spin text-gray-600" />
              <span className=" text-gray-600">Pushing STK</span>
            </div>
          )}
          {pushingStk &&
          mpesaID &&
          (transactionData?.transactionComplete ||
            transactionData?.stkCancelled) ? (
            <div className="  flex flex-row items-center space-x-3 text-gray-800">
              <div className=" rounded-full bg-green-100  p-1">
                <FiCheck className="h-4 w-4 text-green-600" />
              </div>
              <span className=" text-gray-900">Mpesa PIN Entry Done</span>
            </div>
          ) : (
            <div className="  flex flex-row items-center space-x-3 text-gray-800">
              <BiLoaderAlt className=" invisible h-5 w-5 animate-spin text-gray-600" />
              <span className=" text-gray-600">Awaiting Mpesa PIN Entry</span>
            </div>
          )}

          {pushingStk || transactionData ? (
            <>
              {!transactionData?.transactionComplete &&
              !transactionData?.stkCancelled ? (
                <div className="  flex flex-row items-center space-x-3 text-gray-800">
                  <BiLoaderAlt className=" invisible h-5 w-5 animate-spin text-gray-600" />
                  <span className=" text-gray-600">
                    Awaiting Transaction Status
                  </span>
                </div>
              ) : (
                <>
                  {transactionData?.transactionComplete ? (
                    <div className="  flex flex-row items-center space-x-3 text-gray-800">
                      <div className=" rounded-full bg-green-100  p-1">
                        <FiCheck className="h-4 w-4 text-green-600" />
                      </div>
                      <span className=" text-gray-900">
                        Transaction Complete
                      </span>
                    </div>
                  ) : null}
                  {transactionData?.stkCancelled ? (
                    <div className="  flex flex-row items-center space-x-3 text-gray-800">
                      <div className=" rounded-full bg-red-100  p-1">
                        <IoMdClose className="h-4 w-4 text-red-600" />
                      </div>
                      <span className=" text-gray-900">Cancelled</span>
                    </div>
                  ) : null}
                </>
              )}
            </>
          ) : null}
        </div>
      ) : null}

      <div className=" flex w-full select-none flex-col space-y-2 rounded-md bg-[#f7f5f1] px-8 py-8 lg:w-1/2">
        <span className=" text-xl">Summary</span>
        <div className=" flex flex-col space-y-5 divide-y divide-gray-400">
          <div className="flex flex-col space-y-0">
            <div className=" flow-row flex justify-between">
              <span className=" select-none font-medium capitalize">
                {selectedPlan.toLowerCase()}
              </span>
              <span className="">Kshs {Intl.NumberFormat().format(price)}</span>
            </div>
            <div className=" flow-row flex items-center justify-between">
              <span className=" text-sm text-gray-600">Month(s)</span>
              <span className="">{months}</span>
            </div>
            <div className=" flow-row flex items-center justify-between">
              <span className=" text-sm text-gray-600">Wallet</span>
              <span className="">
                {listerData?.wallet.amount > 0 ? "-" : ""} Kshs{" "}
                {Intl.NumberFormat().format(walletDeduct)}
              </span>
            </div>
          </div>

          <div className=" pt-5">
            <div className=" flow-row flex items-center justify-between">
              <span className="  text-sm text-gray-600">Subtotal</span>
              <span className="">
                Kshs {Intl.NumberFormat().format(subtotal)}
              </span>
            </div>
          </div>

          <div className=" pt-5">
            <div className=" flow-row flex justify-between">
              <span className="   text-gray-800">Due Today</span>
              <span className=" text-xl">
                Kshs {Intl.NumberFormat().format(total)}
              </span>
            </div>
          </div>
          {/* <div className="">Current Subscription Expires in 9 days. Wallet will be topped up with KES 9823</div> */}
        </div>
      </div>
    </div>
  );
}

export default ModalPhone;
